import React, { useState } from "react";

export default function SkillsAdminSection({
  lang,
  skills,
  setSkills
}) {
  const [showModal, setShowModal] = useState(false);
  const [editingIdx, setEditingIdx] = useState(null);
  const [skillDraft, setSkillDraft] = useState({ name: "", icon: "" });

  // Abrir modal para agregar
  const openAddModal = () => {
    setEditingIdx(null);
    setSkillDraft({ name: "", icon: "" });
    setShowModal(true);
  };

  // Abrir modal para editar
  const openEditModal = (idx) => {
    setEditingIdx(idx);
    setSkillDraft(skills[idx]);
    setShowModal(true);
  };

  // Guardar skill (nuevo o editado)
  const handleSave = () => {
    let updated = [...skills];
    if (editingIdx === null) {
      updated.push({ ...skillDraft });
    } else {
      updated[editingIdx] = { ...skillDraft };
    }
    setSkills(updated);
    setShowModal(false);
    setEditingIdx(null);
    setSkillDraft({ name: "", icon: "" });
  };

  // Eliminar skill
  const handleDelete = (idx) => {
    setSkills(skills.filter((_, i) => i !== idx));
  };

  return (
    <section className="section">
      <h2 className="sectionTitle">Skills ({lang})</h2>
      <button className="button" style={{ marginBottom: 16 }} onClick={openAddModal}>
        Agregar skill
      </button>
      <ul className="list">
        {skills.map((skill, idx) => (
          <li key={idx} className="listItem" style={{ justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <span>{skill.name}</span>
              {skill.icon && (
                <span style={{ marginLeft: 8 }}>
                  <i className={skill.icon} style={{ fontSize: 18 }}></i>
                </span>
              )}
            </div>
            <div>
              <button
                className="iconBtn"
                title="Editar"
                onClick={() => openEditModal(idx)}
                style={{ marginRight: 6 }}
              >✏️</button>
              <button
                onClick={() => handleDelete(idx)}
                className="buttonDanger"
              >X</button>
            </div>
          </li>
        ))}
      </ul>

      {/* === MODAL (Agregar/Editar Skill) === */}
      {showModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
          background: "#0008", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
        }}>
          <div style={{
            background: "#fff", borderRadius: 10, padding: 32, minWidth: 350, maxWidth: 400, width: "100%",
            boxShadow: "0 4px 32px #0002", display: "flex", flexDirection: "column", gap: 16
          }}>
            <h3 style={{ margin: 0 }}>{editingIdx !== null ? "Editar skill" : "Agregar skill"}</h3>
            <input
              className="input"
              placeholder="Nombre"
              value={skillDraft.name}
              onChange={e => setSkillDraft({ ...skillDraft, name: e.target.value })}
            />
            <input
              className="input"
              placeholder="Clase de icono (ej: devicon-react-original colored)"
              value={skillDraft.icon}
              onChange={e => setSkillDraft({ ...skillDraft, icon: e.target.value })}
            />
            <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
              <button className="button" onClick={handleSave}>
                {editingIdx !== null ? "Guardar cambios" : "Agregar"}
              </button>
              <button className="buttonDanger" onClick={() => setShowModal(false)}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}